export const LAST_CONTENT_UPDATE = "18 September 2026";
export const METHODOLOGY_VERSION = "2026.4";

export const evidenceDefinitions = [
  {
    id: "directly-tested",
    label: "Directly Tested",
    tone: "verified",
    description: "The publication performed and documented a reproducible test, including date, environment, procedure, and result.",
  },
  {
    id: "source-verified",
    label: "Source Verified",
    tone: "verified",
    description: "The claim is supported by a cited first-party document or another clearly identified primary source.",
  },
  {
    id: "vendor-reported",
    label: "Vendor Reported",
    tone: "partial",
    description: "The platform states the claim, but E-Com Benchmark Lab has not independently reproduced it.",
  },
  {
    id: "editorial-assessment",
    label: "Editorial Assessment",
    tone: "disclosed",
    description: "A comparative judgment made under the published scoring framework, not an independently measured fact.",
  },
  {
    id: "not-independently-verified",
    label: "Not Independently Verified",
    tone: "unverified",
    description: "No public claim-level source or reproducible test record is currently attached.",
  },
];

export const currentEvidenceNotice = {
  status: "Evidence + Fit Rating Published",
  detail: "All 550 platform-criterion records show source status. A disclosed publisher-weighted integrated commerce fit rating is published; product-quality scores remain withheld.",
  updated: LAST_CONTENT_UPDATE,
};

export const contentQualityChecklist = [
  "A real user question is answered",
  "Material claims have an evidence status",
  "Dates and commercial relationships are visible",
  "The page adds information beyond another page",
  "Canonical, indexability, and internal links are reviewed",
  "Mobile tables and controls remain usable",
];
